module.exports = __webpack_public_path__ + "img/vm_emblem.801683bc.png";